import { useEffect, useState } from 'react';

const TIMEOUT = 10000;

export const useStatsigTimeout = (isLoading: boolean) => {
  const [isTimeout, setIsTimeout] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timeoutId = setTimeout(() => setIsTimeout(true), TIMEOUT);

      return () => clearTimeout(timeoutId);
    }

    setIsTimeout(false);

    return () => undefined;
  }, [isLoading]);

  return isTimeout;
};
